import type { PimFieldValue } from "@thenounproject/lingo-core";
import { createAction } from "@redux/actions/actionCreators";

const [useSetProductFieldValue, setProductFieldValue] = createAction<{
  productUuid: string;
  productFieldId: string;
  value: PimFieldValue;
}>("product/setFieldValue");

export default useSetProductFieldValue;
export { setProductFieldValue };
